import {Component, Inject, OnInit} from '@angular/core';
import {MAT_SNACK_BAR_DATA, MatSnackBar} from '@angular/material/snack-bar';
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";

@Component({
  selector: 'app-snack-bar',
  templateUrl: './snack-bar.component.html',
  styleUrls: ['./snack-bar.component.css']
})
export class SnackBarComponent implements OnInit {
  safeHtml: SafeHtml = '';

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any,
              public snackBar: MatSnackBar,
              private sanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
    // Sanitize the HTML received
    this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(this.data ?? '');
  }
}
